module.exports = __webpack_public_path__ + "static/img/4.7dbadbb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/4.jpeg
// module id = Pcr7
// module chunks = 45